<section
  [style.background]="node?.background"
  [class.ion-padding]="node?.background ? true : false"
>
  <ion-text
    *ngIf="node?.sectionTitle"
    color="dark"
    class="contact-list-title ion-text-center"
  >
    <h2 class="ion-padding-bottom">
      {{ node?.sectionTitle }}
    </h2>
    <div>
      <strong>{{ node?.title }}</strong>
    </div>
  </ion-text>

  <ion-grid class="ion-justify-content-start">
    <ion-row *ngFor="let item of items">
      <ion-col *ngIf="item.title">
        <ion-text color="dark">
          {{ item.title }}
        </ion-text>
      </ion-col>
      <ion-col *ngIf="item.telSanitized" size="auto">
        <ng-container *ngIf="desktop; else mobileTelLink">
          {{ item.tel }}
        </ng-container>
        <ng-template #mobileTelLink>
          <a [href]="'tel:' + item.telSanitized" target="_blank">
            {{ item.tel }}
          </a>
        </ng-template>
      </ion-col>
      <ion-col *ngIf="item.email" size="auto" class="ion-text-end">
        <a [href]="'mailto:' + item.email" target="_blank">
          <ion-icon name="mail-outline"></ion-icon>
        </a>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-text
    *ngIf="node?.content"
    color="dark"
    class="contact-list-content ion-text-center"
    [innerHtml]="node?.content"
  ></ion-text>
</section>
